import { toast, Zoom } from "react-toastify";

const toastOptions = {
  transition: Zoom,
  position: "bottom-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
};

export const showSuccess = (msg) => toast.success(msg, toastOptions);
export const showError = (msg) => toast.error(msg, toastOptions);
export const showInfo = (msg) => toast.info(msg, toastOptions);
export const showWarning = (msg) => toast.warn(msg, toastOptions);
